import { useCallback, useState } from "react";
import { CashAndBankRepositoryImpl } from "../../data";
import {
  CashBankPaginationEntity,
  CashBankTransactionEntity,
  CashBankTransactionListParams,
  GetCashBankTransactionsUseCase,
} from "../../domain";

const repository = new CashAndBankRepositoryImpl();
const getCashBankTransactionsUseCase = new GetCashBankTransactionsUseCase(
  repository,
);

export const useCashBankTransactions = () => {
  const [transactions, setTransactions] = useState<CashBankTransactionEntity[]>(
    [],
  );
  const [pagination, setPagination] =
    useState<CashBankPaginationEntity | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchTransactions = useCallback(
    async (params: CashBankTransactionListParams) => {
      setLoading(true);
      setError(null);

      try {
        const result = await getCashBankTransactionsUseCase.execute(params);
        setTransactions(result.transactions);
        setPagination(result.pagination);
        return result;
      } catch (error: any) {
        setError(error.message || "Failed to load transactions");
        throw error;
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  const clearError = useCallback(() => setError(null), []);

  return {
    transactions,
    setTransactions,
    pagination,
    loading,
    error,
    fetchTransactions,
    clearError,
  };
};
